import React, { useState } from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet
} from '@react-pdf/renderer';

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  header: {
    marginBottom: 5,
  },
  title: {
    fontSize: 13,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 3,
  },
  headerInfoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  headerInfo: {
    fontSize: 10,
  },
  pageNumberTopRight: {
    fontSize: 10,
    color: 'grey',
    textAlign: 'right',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#eee',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    padding: 5,
    textAlign: 'center',
  },
  tableRow: {
    flexDirection: 'row',
    padding: 5,
    paddingVertical:2,
    borderBottomWidth: 0.5,
    borderBottomColor: '#ccc',
    fontSize: 8, 
  },
  cell: {
    paddingRight: 5,
  },
  colTanggal: { flex: 1 },
  colKeterangan: { flex: 3 },
  colDebit: { flex: 1, textAlign: 'right' },
  colCredit: { flex: 1, textAlign: 'right' },
  colSaldo: { flex: 1, textAlign: 'right' },
  totalRow: {
    flexDirection: 'row',
    padding: 5,
    borderTopWidth: 1,
    borderTopColor: '#000',
    marginTop: 5,
  },
  summaryText: {
    fontSize: 10,
    marginTop: 5,
    textAlign: 'right',
  },
});

const formatDate = (tanggal) => {
  if (!tanggal) return '';
  const [day, month, year] = tanggal.split('-');
  return `${day}-${month}-${year}`; // tetap DD-MM-YYYY
};


const formatDateTime1 = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = ["Januari", "Februari", "Maret", "April", "Mei", "Juni",
                 "Juli", "Agustus", "September", "Oktober", "November", "Desember"][d.getMonth()];
  const year = d.getFullYear();
  const time = d.toTimeString().split(' ')[0];
  return `${day}-${month}-${year} ${time}`;
};

const formatRupiah = (angka) => {
  if (!angka) return '0';
  return angka.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const MyReportmutasiRek = ({ data, saldo_date, userBy }) => {
  const totalDebit = data.reduce((acc, cur) => acc + Number(cur.debit || 0), 0);
  const totalCredit = data.reduce((acc, cur) => acc + Number(cur.credit || 0), 0);
  const saldoAwal = data.length > 0 ? Number(data[0].saldo || 0) : 0;
  const saldoAkhir = saldoAwal + totalDebit - totalCredit;
  const date = formatDateTime1();
  const rowsPerPage = 35;
  const pages = [];

  for (let i = 0; i < data.length; i += rowsPerPage) {
    const currentPageRows = data.slice(i, i + rowsPerPage);
    const isLastPage = i + rowsPerPage >= data.length;

    pages.push(
      <Page size="A4" style={styles.page} key={i}>
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.title}>Laporan Buku Besar Kas/Bank</Text>
          <View style={styles.headerInfoRow}>
            <View>
              <Text style={styles.headerInfo}>Periode: {saldo_date}</Text>             
               <Text>Tanggal :{date} &nbsp;&nbsp; user by : {userBy} </Text>
            </View>
            <Text
              style={styles.pageNumberTopRight}
              render={({ pageNumber, totalPages }) =>
                `Halaman ${pageNumber} dari ${totalPages}`
              }
              fixed
            />
          </View>
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          <Text style={[styles.cell, styles.colTanggal]}>Tanggal</Text>
          <Text style={[styles.cell, styles.colKeterangan]}>Keterangan</Text>
          <Text style={[styles.cell, styles.colDebit]}>Debit</Text>
          <Text style={[styles.cell, styles.colCredit]}>Credit</Text>
          <Text style={[styles.cell, styles.colSaldo]}>Saldo</Text>
        </View>

        {/* Table Rows */}
        {currentPageRows.map((item, idx) => (
          <View style={styles.tableRow} key={idx}>
            <Text style={[styles.cell, styles.colTanggal]}>{formatDate(item.date_voucher)}</Text>
            <Text style={[styles.cell, styles.colKeterangan]}>{item.keterangan}</Text>
            <Text style={[styles.cell, styles.colDebit]}>
              {formatRupiah(item.debit || 0)}
            </Text>
            <Text style={[styles.cell, styles.colCredit]}>
              {formatRupiah(item.credit || 0)}
            </Text>
            <Text style={[styles.cell, styles.colSaldo]}>
              {formatRupiah(item.saldo || 0)}
            </Text>
          </View>
        ))}

        {/* Total & Summary hanya di halaman terakhir */}
        {isLastPage && (
          <>
            <View style={styles.totalRow}>
              <Text style={[styles.cell, styles.colTanggal]}></Text>
              <Text style={[styles.cell, styles.colKeterangan]}>Total</Text>
              <Text style={[styles.cell, styles.colDebit]}>
                {formatRupiah(totalDebit)}
              </Text>
              <Text style={[styles.cell, styles.colCredit]}>
                {formatRupiah(totalCredit)}
              </Text>
              <Text style={[styles.cell, styles.colSaldo]}></Text>
            </View>
            <View>
              <Text style={styles.summaryText}>Saldo Awal: {formatRupiah(saldoAwal)}</Text>
              <Text style={styles.summaryText}>Saldo Akhir: {formatRupiah(saldoAkhir)}</Text>
            </View>
          </>
        )}
      </Page>
    );
  }

  return <Document>{pages}</Document>;
};

export default MyReportmutasiRek;
